import { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useAuth0 } from '@auth0/auth0-react';

import handleResponse from '../../common/ResponseHandler'

const EditProjectProvider = (props) => {
    const [state, setState] = useState({
        updateLoading: false,
        providers: [],
        selectedProviderId: 0,
        updateServiceLoading: false
    });

    const { getAccessTokenSilently } = useAuth0();

    const saveChanges = async () => {
        try {
            var token = await getAccessTokenSilently();
            const response = await axios.get(`api/homeproject/updateprovider/${props.projectId}/${state.selectedProviderId}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            handleResponse(response, "Error Loading Login Data");
            if (!response.data.isError) {
                await setState({
                    ...state,
                    loginUserData: response.data.data
                });
            }
            props.getHomeProject();
        } catch (error) {
            toast.error("Error Loading Login Data", { toastId: "error-loading-login-data" });
        }
    };

    const getProvider = async () => {
        var token = await getAccessTokenSilently();
        const providerResponse = await axios.get("api/provider/getall", {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        setState({
            ...state,
            providers: providerResponse.data.data,
        });
    }

    const updateSelectedProvider = (providerId) => {
        setState({ ...state, selectedProviderId: providerId });
    }

    useEffect(() => {
        getProvider();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className="container">
            <div className="row">
                <div className="title-sub-text align-left pt-1 col-12">
                    <div className="row">
                        <div className="col-md-8 col-sm-12">
                            <select
                                id="select-service-category"
                                value={state.selectedProviderId}
                                className="form-select text-primary"
                                onChange={(event) => updateSelectedProvider(event.target.value)}
                            >
                                <option className="text-black" value={0}>Select a provider</option>
                                {state.providers?.map((provider, index) => {
                                    return (
                                        <option
                                            key={"catOption-" + index}
                                            className="text-black"
                                            value={provider.id}
                                        >
                                            {provider.name}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                    </div>
                </div>
                <div style={{ display: state.selectedServiceId === 0 ? "none" : "" }} className="col-12 mt-2" align="right">
                    <button
                        disabled={state.updateServiceLoading}
                        className="btn btn-outline-success"
                        onClick={saveChanges}>Update Provider
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EditProjectProvider;